import { Navigate, Outlet } from 'react-router-dom';

import { useAppSelector } from '@/store';
import { homeRouteFor, SERVICE_ROLE } from '@/utils/constants';

// Guards the Service workspace. Assumes it is nested inside ProtectedRoute, so
// the user is already authenticated; here we only check the Service jobRole
// (admins may also view it for support/oversight).
const ServiceRoute = () => {
  const user = useAppSelector((state) => state.auth.user);
  const allowed = user?.jobRole === SERVICE_ROLE || user?.role === 'admin';

  if (!allowed) {
    return <Navigate to={homeRouteFor(user)} replace />;
  }

  return <Outlet />;
};

export default ServiceRoute;
